export const firebaseConfig = {
    apiKey: "AIzaSyDqYnZ7ze5MjJAQgu_myntGl4RhsG3Mikc",
    authDomain: "kth-project-det-eme-hum-sof.firebaseapp.com",
    projectId: "kth-project-det-eme-hum-sof",
    storageBucket: "kth-project-det-eme-hum-sof.appspot.com",
    messagingSenderId: "397780542691",
    appId: "1:397780542691:web:3103f229db5c0c3fdd11d6",
    databaseURL: "https://kth-project-det-eme-hum-sof-default-rtdb.europe-west1.firebasedatabase.app"
  };